/**
 * Enumeration of various task views supported by Planner
 */ export var BoardDisplayMode = /*#__PURE__*/ function(BoardDisplayMode) {
    /**
     * Displays tasks in a board view
     */ BoardDisplayMode[BoardDisplayMode["Board"] = 0] = "Board";
    /**
     * Displays tasks in a list view
     */ BoardDisplayMode[BoardDisplayMode["List"] = 1] = "List";
    return BoardDisplayMode;
}({});
